module.exports = __webpack_public_path__ + "static/media/44532953_2199901696751676_829079656228454400_o-thumb.4a666098.jpg";